module.exports = __webpack_public_path__ + "static/media/reading-list-back-image.a4bd9483.png";